// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-panel":"styles__split-panel___3OW1a","splitPanel":"styles__split-panel___3OW1a","sub-panel":"styles__sub-panel___1m037","subPanel":"styles__sub-panel___1m037","button-group":"styles__button-group___1Z8sx","buttonGroup":"styles__button-group___1Z8sx"};
    if(module.hot) {
      // 1771371846164
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  